import { render, staticRenderFns } from "./SafetyOversightCommittee.vue?vue&type=template&id=6fb51fd6&"
import script from "./SafetyOversightCommittee.vue?vue&type=script&lang=js&"
export * from "./SafetyOversightCommittee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports